import styled from "@emotion/styled";
import { Colors } from "../../../../../colors";
import { Grid } from '@mui/material';


export const HeaderReservationStyled = {
    Container: styled(Grid)<any> `
        display: flex;
        width: 100%;
        background: ${Colors.Transparent};
        margin-top: 37px;
        margin-bottom: 26px;
        justify-content: space-between;
    `,
    ContainerClickableText: styled(Grid)<any> `
    
    `,

    TextButton: styled.p<any>`
        font-family: EncodeSans-Regular;
        color: ${Colors.White};
        font-size: 14px;
        font-weight: 500;
        font-style: normal;
    `,
}